export default {
  id: 'SideMenu',
  code: 'CN',
  text: {
    '{ticket_amount}': '{ticket_amount}人',
    'Administration': '教务管理',
    'Schedules': '课表',
    'Students': '学员',
    'Classes': '班级',
    'Private Classes': '私课',
    'Teachers': '老师',
    'Classrooms': '教室',
    'Announcements': '公告',
    'Finance': '财务管理',
    'Statement Detail': '收支明细',
    'Monthly Summary': '月度汇总',
    'Marketing': '营销管理',
    'Posters': '海报',
    'Contacts': '联系人',
    'School Settings': '学校设置',
    'Information': '学校信息',
    'Permissions': '权限设置',
    'Website': '官网设置',
    'Terms and Conditions': '注册条款',
    'Please upgrade to higher subscription plan to unlock this feature': '请升级您的计划以解锁此功能',
    'Activity Log': '操作记录',
    'Dashboard': '仪表盘',
    'Home':'控制台',
  }
}



// WEBPACK FOOTER //
// ./src/containers/Main/locale.js